module.exports = __webpack_public_path__ + "img/Fondo_Titulo_Optimo.66a5b6ac.svg";